/**
 * Build-time values for the marketing pages, from the repo's .env or the build environment (vite.config.ts defines
 * __PAIRING_SITE__). They are public by nature: a canonical URL, the partner email address and Denamico's HubSpot
 * portal ID. Runtime config (window.__PAIRING_CONFIG__, injected by serve.mjs) overrides the demo
 * video once the page is hydrated, so a deploy can set them without a rebuild.
 */
export interface SiteEnv {
  /** Canonical origin, no trailing slash. PAIRING_SITE_URL, default https://pairing.denamico.com. */
  siteUrl: string;
  /** PAIRING_PARTNER_EMAIL: the partner team's address on the rep page. */
  partnerEmail: string;
  /** PAIRING_CONTACT_PORTAL_ID: Denamico's HubSpot portal, for the tracking code. */
  contactPortalId: string;
  /** PAIRING_HS_TRACKING=on loads HubSpot's tracking code (off by default, pending a consent decision). */
  hsTracking: boolean;
  /** PAIRING_DEMO_VIDEO_URL: the client page's demo video (YouTube, Vimeo, Loom or a video file). Without it the video
   * section is left out. Also settable at runtime. */
  demoVideoUrl: string;
}

declare const __PAIRING_SITE__: Partial<SiteEnv> | undefined;

const defined: Partial<SiteEnv> = typeof __PAIRING_SITE__ !== 'undefined' ? __PAIRING_SITE__ : {};

export const siteEnv: SiteEnv = {
  siteUrl: (defined.siteUrl || 'https://pairing.denamico.com').replace(/\/$/, ''),
  partnerEmail: defined.partnerEmail ?? '',
  contactPortalId: defined.contactPortalId ?? '',
  hsTracking: defined.hsTracking ?? false,
  demoVideoUrl: defined.demoVideoUrl ?? '',
};

/** True in `vite` dev and in tests; false in every production build, the prerender included. */
export const isDev = import.meta.env.DEV;
